import classNames from 'classnames';
import React from 'react';
import RightsWrapper from '../../elements/RightsWrapper';
import Tooltip from '../../elements/Tooltip';
import { DeleteIcon, InfoIconOutlined, PenIcon } from '../../svgs/ExpressonSVGs';

export interface UserManagementRowData {
    name: string;
    email: string;
    phone: string;
    rights: string;
    identifier?: string;
}

type UserManagementTableRowProps = {
    wrapperClasses?: string;
    rowData: UserManagementRowData;
    onDelete?: () => void;
    onEdit?: () => void;
}

const UserManagementTableRow: React.FC<UserManagementTableRowProps> = ({ wrapperClasses, rowData, onDelete, onEdit }) => {
    const onlySuperUserCanEdit = rowData.rights === 'Administratör';
    return (
        <>
            <div className={classNames(
                'user-management-table-single-row',
                wrapperClasses
            )}
            >
                <div className="user-info">
                    <span>{rowData.name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2)}</span>
                    <div>
                        <span data-label="Namn">{rowData.name}</span>
                        <span data-label="Personnummer">{rowData.identifier}</span>
                    </div>
                </div>

                <span className="user-email" data-label="E-post">
                    {rowData.email}
                </span>

                <span className="user-phone" data-label="Telefonnummer">
                    {rowData.phone}
                </span>

                <span className="user-rights" data-label="Rättigheter">
                    <div>
                        {rowData.rights}
                        {rowData.rights === '-' && (
                            <Tooltip text={'Vänligen uppdatera kontots rättigheter'} position={'top'}>
                                <InfoIconOutlined width={24} height={24} />
                            </Tooltip>
                        )}
                    </div>

                </span>

                <div className="row-actions">
                    {rowData.rights === 'Administratör' ? (
                        <span className="empty-edit-placeholder" />
                    ) : (
                        <RightsWrapper
                            disableButtonText={''}
                            disableButtonIcon={<PenIcon width={22} height={22} />}
                            disableButtonClasses="Button body-text no-style-button disable-fill-color"
                            toolTipPosition={'top-end'}
                            onlySuperUser={onlySuperUserCanEdit}
                            ariaLabel="Redigera användare"
                            fetchAnimationWidth={30}
                            fetchAnimationHeight={30}
                            fetchAnimationBorderRadius={8}

                        >
                            <button className="Button no-style-button edit" aria-label="Redigera användare" onClick={onEdit}>
                                <PenIcon width={22} height={22} />
                            </button>
                        </RightsWrapper>
                    )}

                    {rowData.rights === 'Administratör' ? (
                        <span className="empty-delete-placeholder" />
                    ) : (
                        <RightsWrapper
                            disableButtonText={''}
                            disableButtonIcon={<DeleteIcon width={28} height={28} />}
                            disableButtonClasses="Button body-text no-style-button disable-fill-color"
                            toolTipPosition={'top-end'}
                            ariaLabel={"Ta bort användare"}
                            fetchAnimationWidth={30}
                            fetchAnimationHeight={30}
                            fetchAnimationBorderRadius={8}
                            fetchingAnimationMarginRight={10}
                        >
                            <button className="Button no-style-button delete" aria-label="Ta bort användare" onClick={onDelete}>
                                <DeleteIcon width={28} height={28} />
                            </button>
                        </RightsWrapper>

                    )}
                </div>
            </div>
        </>
    )
}
export default UserManagementTableRow
